import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import SidePane from '@design-system/SidePane/SidePane';
import PageLayout from './PageLayout';
import { mediaQuery } from '@design-system/Breakpoints/Breakpoints';
import { useSelector } from 'react-redux';
import { getUser } from '@app/auth/redux/selectors';
import { Redirect } from 'react-router-dom';

export const MainLayout = styled.main`
  background-color: '#fff';
  color: ${(props) => (props.color ? props.color : '#fff')};
  border-radius: 4px;
  border: ${(props) => (props.border ? props.border : 'none')};
  flex-direction: column;

  ${mediaQuery.desktop`
  width: 100%;
  height: 100vh;
  display: grid;
  grid-template-columns: 200px auto;
  grid-template-areas:
    'sideMenu content'
    'sideMenu content';
    grid-gap: 20px;
 
    `}
  img {
  }

  .m-4 {
    margin: 2rem 0;
  }

  .pointer {
    cursor: pointer;
  }
  .table-icons {
    text-align: center;
  }

  .button-middle {
    display: flex;
    justify-content: center;
  }
  .table-icon {
    width: 1.5rem;
    &:last-child {
      padding-left: 1rem;
    }
  }
`;

export const Layout = ({ children }) => {
  const user = useSelector(getUser);
  const token = localStorage.getItem('x-access-token');
  if (user.email_verified && token) {
    return (
      <MainLayout>
        <SidePane />
        <PageLayout>{children}</PageLayout>
      </MainLayout>
    );
  } else {
    localStorage.removeItem('x-access-token');
    return <Redirect to="/login" />;
  }
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};
